import React from 'react';
import { hot } from 'react-hot-loader';
import Link from 'redux-first-router-link';
import { connect } from 'react-redux';
import ProductItem from '../../Category/ProductItem';
import Pagination from '../../../hocs/Pagination/Pagination';
import { translate, prefix } from '../../../utils/locale';
import { unique } from '../../../utils/array';
import s from './Products.scss';

const Products = ({ setup, productCache, content, isProduct = false, isDeprecatedTemplate = false }) => {
	if (!productCache || !productCache[setup.market] || !productCache[setup.market][setup.pricelist] || !content) return null;

	let completeProductList = [];
	const cache = productCache[setup.market][setup.pricelist];
	const HeaderTag = content?.headerDetails?.type || 'h2';
	const headerText = content.headerText ? <HeaderTag className={[s.products_headline, `u_fontSize__${content.headerDetails.size}`].join(' ')} style={{ textAlign: content.headerDetails.align.horizontal }}>{ translate(setup, content.headerText) }</HeaderTag> : null;
	const link = content.link ? <Link className={s.products_link} to={prefix(setup, translate(setup, content.link, 'url'))}>{ translate(setup, content.link, 'title') }</Link> : null;
	const productPicker = !content.gridSlider;

	if (content.individual) {
		if (Array.isArray(content.individual) || Array.isArray(content.individual.products)) completeProductList = [...completeProductList, ...(content.individual.products || content.individual)];
	} else if (content.category) {
		content.category.forEach((category) => {
			// Uses default en
			completeProductList = [...completeProductList, ...(cache.filterArrays.categories[category.value.en] ? cache.filterArrays.categories[category.value.en] : [])];
		});
	} else if (content.campaign) {
		content.campaign.forEach((campaign) => {
			completeProductList = [...completeProductList, ...cache.filterArrays[campaign.value]];
		});
	} else if (content.brand) {
		content.brand.forEach((brand) => {
			completeProductList = [...completeProductList, ...cache.filterArrays.brands[brand.value]];
		});
	}

	completeProductList = unique(completeProductList.filter((p) => cache.products[p] && (isProduct === false || isProduct !== p)));
	if (content.limit !== undefined) {
		completeProductList = completeProductList.slice(0, parseInt(content.limit, 10));
	}

	return (
		<div className={[s.products, 'u_productPicker', `productsPerRow_${content.perRow}`, (parseInt(content.perRow, 10) > completeProductList.length ? 'u_center' : null)].join(' ')}>
			{ headerText }
			<Pagination ListComponent={ProductItem} list={completeProductList} cache={productCache[setup.market][setup.pricelist].products} currentPath={content.identifier || 'Product Picker'} canonical productPicker={productPicker} isDeprecatedTemplate={isDeprecatedTemplate} />
			{ link }
		</div>
	);
};

const mapState = ({ environment, productCache }, { content }) => ({
	setup: environment.setup,
	productCache,
	content,
});

export default hot(module)(connect(mapState)(Products));
